import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import MealsTable from './MealsTable'

const MealsResult = ({
  meals = [],
  onEdit = () => {},
  onDelete = () => {},
  ...rest
}) => {
  const [page, setPage] = useState(0);
  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <MealsTable
        data={meals}
        dataKeysSequence={[
          'food',
          'quantity',
          'time',
          'actions'
        ]}
        headers={[ 'food', 'Quantity','Time','Actions']}
        handlePageChange={handlePageChange}
        page={page}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Card>
  );
};

MealsResult.propTypes = {
  meals: PropTypes.array.isRequired
};

export default MealsResult;
